<template>
  <OnBoarding :maxContentWidth="420">
    <template>
      <CRow>
        <CCol col="12">
          <OnBoardingHeader :title="$gettext('Verify your email')"/>
        </CCol>
        <CCol col="12 mb-4">
          <div class="text-center" style="font-size: 16px">
            <translate translate-context="validate.info">We sent a verification code to:</translate>&nbsp;
            <span class="font-weight-semi-bold">{{ email }}</span>
          </div>
        </CCol>
        <CCol col="12">
          <TokenInput
            :validating="validating"
            :error-message="errorMessage"
            :show-resend="true"
            @complete="onTokenComplete"
            @resend="resendCode"
            ref="tokenInput"
          />
        </CCol>
      </CRow>
    </template>
  </OnBoarding>

</template>

<script>
import {mapActions} from "vuex";
import {methods} from "@/domain/login/mixin";
import OnBoarding from "@/domain/login/OnBoarding.vue";
import OnBoardingHeader from "@/domain/login/components/OnBoardingHeader.vue";
import TokenInput from "@/domain/login/components/TokenInput.vue";

export default {
  name: 'Validate',
  components: {OnBoardingHeader, OnBoarding, TokenInput},
  emits: ['complete', 'cancel'],
  data() {
    return {
      email: null,
      validating: false,
      validationError: false
    }
  },
  computed: {
    errorMessage() {
      if (this.validationError) {
        return this.$pgettext('validate.error', 'Invalid code')
      }
      return null
    }
  },
  mounted() {
    this.email = this.$route.params.email
  },
  methods: {
    ...methods,
    ...mapActions('login', [
      'resendValidationCode',
      'validateCode'
    ]),
    resendCode() {
      this.resendValidationCode({email: this.email})
      this.validationError = false
    },
    async onTokenComplete(code) {
      if (this.validating) return
      
      this.validating = true
      this.validationError = false
      
      try {
        await this.validateCode({code: code, email: this.email})
        await new Promise(resolve => setTimeout(resolve, 1500))
        await this.afterLogin()
      } catch (e) {
        this.validationError = true
        if (this.$refs.tokenInput) {
          this.$refs.tokenInput.reset()
        }
      } finally {
        this.validating = false
      }
    }
  }
}
</script>